// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-and-manage-users-page .ev-link-tabs{margin-top:0}`, "",{"version":3,"sources":["webpack://./src/pages/manage-users-tabs-view/ManageUsersTabsView.scss"],"names":[],"mappings":"AACC,4CACC,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
